// NOTE: Dependencies: jQuery, Defiant

(function ($) {
	$.fn.lmPartnerPortalProductSearch = function(options) {

		const $context = $(this);

		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body'),
			$document: $(document),
			$addProduct: $('#partnerPortalProductAdd'),
			loaderClass: ('field__element--loading'),
			predictivePanelClass: ('field__partner-portal-predictive-panel--active'),
			partnerPortalItem: '.field__partner-portal-product-item',
			finalId: '',
			finalLabel: '',
			finalPriceBookId: '',
			buttonClass: 'button--disabled',
			$productInput: $('#products'),
			$removeLabel: $('#removeLabel'),
			$productAdded: $('#partnerPortalProducts'),
			purchaseProgram: false
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
			settings.ajaxUrl = $context.attr('data-predictive');
			settings.$parent = $context.parent();
			settings.$predictivePanel = settings.$parent.find('.field__partner-portal-predictive-panel');
		};

		methods.clearAllPredictiveData = function() {
			settings.$predictivePanel.html('').removeClass(settings.predictivePanelClass);
		}

		// Bind events
		methods.events = function() {
			var timer;

			$context.off('input.lmPartnerPortalProductSearch').on('input.lmPartnerPortalProductSearch', function(event) {

				settings.searchValue = this.value;
				settings.finalId = '';
				settings.finalLabel = '';
				settings.finalPriceBookId = '';
				settings.$addProduct.addClass(settings.buttonClass);

				if (settings.searchValue.length > 2) {
					settings.$parent.addClass(settings.loaderClass);

					clearTimeout(timer);
					timer = setTimeout(function() {
						methods.ajaxCheck();
					}, 500);
				}
			});

			settings.$document.off('keyup.lmPartnerPortalProductSearch').on('keyup.lmPartnerPortalProductSearch', '.product-row__quantity input', function(event) {
					var $this = $(event.target),
						value = parseInt(event.target.value),
						$productRow = $this.closest('.product-row'),
						previousQuantity = $productRow.attr('data-quantity');

					if (isNaN(value) || value === 0) {
						$this.val(0);
						$productRow.attr('data-quantity',0);

						if (settings.purchaseProgram) {
							$productRow.find('.product-row__total span').html(parseFloat(0).toFixed(2));
						}
					} else {
						$this.val(value);
						$productRow.attr('data-quantity',value);

						if (settings.purchaseProgram) {
							var totalPrice = $productRow.attr('data-price') * value;
							$productRow.find('.product-row__total span').html(parseFloat(totalPrice).toFixed(2));
						}
					}

					var currentHiddenInputValue = $productRow.attr('data-id') + ' (' + $productRow.attr('data-pricebook-id') + '):' + previousQuantity,
						newHiddenInputValue = $productRow.attr('data-id') + ' (' + $productRow.attr('data-pricebook-id') + '):' + $productRow.attr('data-quantity');

					methods.updateInputValue(currentHiddenInputValue,newHiddenInputValue);
			});

			settings.$document.on('click', settings.partnerPortalItem, function(event) {
				event.preventDefault();

				methods.setFinalItem($(this));
			})

			settings.$document.on('click', '.product-row__remove button', function(event) {
				event.preventDefault();

				var $this = $(event.target),
						$productRow = $this.closest('.product-row'),
						id = $productRow.attr('data-id'),
						pricebookId = $productRow.attr('data-pricebook-id'),
						quantity = $productRow.attr('data-quantity');

				methods.updateInputValue(id + ' (' + pricebookId + '):' + quantity, '');
				$productRow.remove();
				methods.togglePanel();
			})

			settings.$addProduct.off('click.lmPartnerPortalProductSearch').on('click.lmPartnerPortalProductSearch', function(event) {
				event.preventDefault();

				if (!settings.$addProduct.hasClass(settings.buttonClass) && settings.finalId !== '' && settings.finalLabel !== '' && settings.finalPriceBookId !== '') {
					methods.addItem();
					methods.togglePanel();
				}
			});

			// Clear panel on click outside of div
			settings.$document.mouseup(function(event) {
				// if the target of the click isn't the container nor a descendant of the container. Then clear all data.
				if (!settings.$predictivePanel.is(event.target) && settings.$predictivePanel.has(event.target).length === 0) {
					if (settings.$predictivePanel.hasClass(settings.predictivePanelClass)) {
						methods.clearAllPredictiveData();
					}
				}
			});
		};

		methods.togglePanel = function() {
			if (settings.$productAdded.find('.product-row').length == 1) {
				settings.$productAdded.removeClass('partner-portal-products--show');
			} else {
				settings.$productAdded.addClass('partner-portal-products--show');
			}
		}

		methods.addItemMarkup = function() {
			if (!settings.purchaseProgram) {
				settings.$productAdded.append(
				'<div data-quantity="1" data-id="' + settings.finalId + '" class="product-row" data-pricebook-id="' + settings.finalPriceBookId + '">' +
				'<div class="product-row__id">' + settings.finalId + '</div>' +
				'<div class="product-row__quantity field field--inline"><input type="text" value="1" class="field__element field__element--input" /></div>' +
				'<div class="product-row__remove"><button class="button" data-icon-before="close">' + settings.$removeLabel.val() + '</button></div>' +
				'</div>');
	     } else {
					settings.$productAdded.append(
					'<div data-quantity="1" data-currency="' + settings.finalCurrency + '" data-price="' + settings.finalPrice + '" data-id="' + settings.finalId + '" class="product-row" data-pricebook-id="' + settings.finalPriceBookId + '">' +
					'<div class="product-row__id">' + settings.finalId + '</div>' +
					'<div class="product-row__price">' + settings.finalCurrency + settings.finalPrice + '</div>' +
					'<div class="product-row__quantity field field--inline"><input type="text" value="1" class="field__element field__element--input" /></div>' +
					'<div class="product-row__total">' + settings.finalCurrency + '<span>' + settings.finalPrice + '</span></div>' +
					'<div class="product-row__remove"><button class="button" data-icon-before="close">' + settings.$removeLabel.val() + '</button></div>' +
					'</div>');
	     }
		}

		methods.addItem = function() {
			var currentValue = settings.$productInput.val();

			if (currentValue.indexOf(settings.finalId) !== -1) {
				var $item = settings.$productAdded.find('[data-id="' + settings.finalId + '"]'),
					currentValue = $item.attr('data-quantity'),
					newValue = parseInt(currentValue) + 1;
				
				methods.updateInputValue(settings.finalId + ' (' + settings.finalPriceBookId + '):' + currentValue,settings.finalId + ' (' + settings.finalPriceBookId + '):' + newValue);

				$item.find('.product-row__quantity input').val(newValue);
				$item.attr('data-quantity',newValue);

			} else {
				methods.addInputValue();
				methods.addItemMarkup();
			}
		}

		methods.updateInputValue = function(oldAmount,newAmount) {
			var replaceInput = settings.$productInput.val().replace(oldAmount,newAmount);
			settings.$productInput.val(replaceInput);

			if (settings.$productInput.val().endsWith(',')) {
				var resetValue = settings.$productInput.val().replace(/.$/,"");
				settings.$productInput.val(resetValue);
			}
		}

		methods.addInputValue = function() {
			var currentValue = settings.$productInput.val();

			if (currentValue !== '') {
				var newValue = currentValue + ',' + settings.finalId + ' (' + settings.finalPriceBookId + '):1';
			} else {
				var newValue = settings.finalId + ' (' + settings.finalPriceBookId + '):1';
			}

			settings.$productInput.val(newValue);
		}

		methods.setFinalItem = function($item) {
			settings.finalLabel = $item.text();
			settings.finalId = $item.attr('data-id');
			settings.finalPriceBookId = $item.attr('data-pricebook-id');

			if (settings.purchaseProgram) {
				settings.finalPrice = $item.attr('data-price');
				settings.finalCurrency = $item.attr('data-currency');
			}

			methods.clearAllPredictiveData();
			$context.val(settings.finalLabel);

			settings.$addProduct.removeClass(settings.buttonClass);

		}

		// Ajax Check
		methods.ajaxCheck = function() {

			if (!settings.dataSnapShot) {
				methods.ajaxCall();
			} else {
				methods.searchData();
			}
		}

		methods.ajaxCall = function() {
			$.ajax({
				type: 'GET',
				dataType: 'json',
				url: settings.ajaxUrl,
				success: function(data, textStatus, jqXHR) {
					settings.dataSnapShot = Defiant.getSnapshot(data);
					methods.searchData();
				},
			  error: function(XMLHttpRequest, textStatus, errorThrown) {
					// TODO error handling
				}
			});
		};

		methods.searchData = function() {
			
			settings.result = JSON.search(settings.dataSnapShot, "//*[contains(id, '"+ settings.searchValue +"')]");

			if (settings.result.length > 0) {
				var firstItem = settings.result[0],
					length = Object.keys(firstItem).length;
				
				if (length > 4) {
					settings.purchaseProgram = true;
				}

				methods.populatePanel();
			}
		}

		methods.populatePanel = function() {
			var html = '';
			$.each(settings.result, function() {
				var result = this;

				if (!settings.purchaseProgram) {
					html += '<li><button class="field__partner-portal-product-item" data-id="' + result.id + '" data-pricebook-id="' + result.pricebook_id + '">' + result.label + '</button></li>';
				} else {
					html += '<li><button class="field__partner-portal-product-item" data-currency="' + result.currency + '" data-price="' + result.price + '" data-id="' + result.id + '" data-pricebook-id="' + result.pricebook_id + '">' + result.label + '</button></li>';
				}

			});

			settings.$predictivePanel.html(html).addClass(settings.predictivePanelClass);
		}

		// On load function.
		methods.initContext = function () {
			methods.setCurrentSettings();
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};	
	
		// NOTE: Method you'd like initialized on a per context basis.
		methods.initContext($(this));

		// Run once methods when jquery plugin is called.
		methods.events(this);

		
	};

	if($('#partnerPortalProductInput').length) {
		$('#partnerPortalProductInput').lmPartnerPortalProductSearch();
	}

}(jQuery));